import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';

const PaymentExpiredSummary = ({ partner }) => (
    <StatusSummaryButton
        href="/betalingsfrist-har-gatt-ut"
        statusSummary={`${partner.name} har ikke betalt.`}
    >
        Betalingsfristen har gått ut
    </StatusSummaryButton>
);

PaymentExpiredSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
};

export default PaymentExpiredSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/summaries/paymentExpiredSummary.jsx